const hasYm = () => !!window.ym;

const COUNTER_ID = 26001372;

export const ymPushEvent = (payload = {}, key = 'params') => {
  if (hasYm()) {
    window.ym?.(COUNTER_ID, key, payload);
  }
};

export const handleYmAnalytics = (params: any) => {
  ymPushEvent({
    page_category: {
      personal_account: params,
    },
  });
};

export const handleNewYmAnalytics = (params: any) => {
  ymPushEvent({
    personal_account: params,
  });
};

type mobileBannerAnalyticsType = {
  action: string;
  name: string;
  position: number;
  type: string;
  url: string;
};

export const handleMobileBannerAnalytics = ({
  action,
  position,
  type,
  name,
  url,
}: mobileBannerAnalyticsType) => {
  handleYmAnalytics({
    banners_ev_: {
      [action]: {
        [`${type}_${position}`]: {
          [name]: url,
        },
      },
    },
  });
};
